import api from '../../../lib/api';
import type {
  InfoSecurityIncidentPayload,
  InfoSecurityIncidentSummary,
  PaginatedInfoSecurityIncidents,
} from './types';

export interface ListInfoSecurityIncidentsParams {
  page?: number;
  pageSize?: number;
  type?: string;
  severity?: string;
  status?: string;
  from?: string;
  to?: string;
  search?: string;
}

export const fetchInfoSecurityIncidents = async (
  params: ListInfoSecurityIncidentsParams = {},
): Promise<PaginatedInfoSecurityIncidents> => {
  const { data } = await api.get<PaginatedInfoSecurityIncidents>('info-security-incidents', {
    params,
  });
  return data;
};

export const fetchInfoSecurityIncident = async (id: string): Promise<InfoSecurityIncidentSummary> => {
  const { data } = await api.get<InfoSecurityIncidentSummary>(`info-security-incidents/${id}`);
  return data;
};

export const createInfoSecurityIncident = async (payload: InfoSecurityIncidentPayload) => {
  const { data } = await api.post('info-security-incidents', payload);
  return data;
};

export const updateInfoSecurityIncident = async (
  id: string,
  payload: Partial<InfoSecurityIncidentPayload>,
) => {
  const { data } = await api.put(`info-security-incidents/${id}`, payload);
  return data;
};

export const transitionInfoSecurityIncidentStatus = async (
  id: string,
  status: InfoSecurityIncidentSummary['status'],
) => {
  const { data } = await api.patch(`info-security-incidents/${id}/status`, { status });
  return data;
};

export const escalateInfoSecurityIncident = async (
  id: string,
  payload?: { title?: string; description?: string },
) => {
  const { data } = await api.post(`info-security-incidents/${id}/escalate`, payload ?? {});
  return data as { incidentId: string; qmsRecordId: string };
};
